import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store';
import React from 'react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const dsn = process.env.REACT_APP_SENTRY_DSN;
const environment = process.env.REACT_APP_ENVIRONMENT;

Sentry.init({
  dsn,
  environment,
  ignoreErrors: ['ResizeObserver loop limit exceeded', 'NetworkError'],
});

document.title =
  environment === 'dev'
    ? 'Certificate of Service Dev'
    : environment === 'stage'
      ? 'Certificate of Service Stage'
      : 'Certificate of Service';

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
